import * as types from '../types'
import PassportApi from '@/api/passport'
import Auth from '@/utils/auth'

export default {
  state: {
    operator: {
      admin_name: '未知用户',
      admin_full_name: '未知用户',
      admin_mobile: '',
      channel_id: 0
    }
  },
  mutations: {
    [types.SET_OPERATOR]: (state, data) => {
      state.operator.admin_name = data.admin_name;
      state.operator.admin_mobile = data.admin_mobile;
      state.operator.admin_full_name = data.admin_full_name;
    },
    [types.LOGOUT]: (state) => {
      Auth.removeToken()
      state.operator = {};
    }
  },
  actions: {
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        PassportApi.login(data).then(response => {
          commit(types.SET_OPERATOR, response.data);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        PassportApi.logout().then(response => {
          commit(types.LOGOUT);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientLogout({ commit }) {
      new Promise((resolve) => {
        commit(types.LOGOUT);
        resolve()
      })
    },
    GetCurrentAdmin({ commit }) {
      return new Promise((resolve, reject) => {
        PassportApi.currentAdmin().then(res => {
          const operatior = res.data
          commit(types.SET_OPERATOR, operatior)
          resolve(operatior);
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/passport.js